import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { addTemplate, getapp, getTemplateInfobyID, getTemplateList, getTemplateParse, readTemplate, updateTemplate, validateIdentifers } from './template';

// Define your template field type
interface TemplateField {
  name: string;
  value?: string;
  verified?: boolean;
}

// Define the Template state
interface TemplateState {
  data: TemplateField[]; // list of fields
  templateStructure:any;
  loading: boolean;
  error: string | null;
  selectedField: string | null;
}

// Initial state
const initialState: TemplateState = {
  data: [],
  loading: false,
  templateStructure:[],
  error: null,
  selectedField: null,
};



const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    templateStructureInfo: (state, action)=>{
      state.templateStructure = action.payload
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplateList.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
  
      builder
      .addCase(getTemplateInfobyID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      builder
      .addCase(getTemplateParse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    
      builder
      .addCase(validateIdentifers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    
      builder
      .addCase(readTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      builder
      .addCase(addTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      builder
      .addCase(updateTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      builder
      .addCase(getapp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
   
  },
});

export const {
  templateStructureInfo

} = templateSlice.actions;

export default templateSlice.reducer;
